import { render } from "./TitleLink.vue?vue&type=template&id=6af2e9de"
import script from "./TitleLink.vue?vue&type=script&lang=js"
export * from "./TitleLink.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__